import React from 'react';
import styles from './PeopleModal.module.css';
import closeIcn from '../../assets/ic-close.svg';
import FollowerList from './FollowerList';
import { useSelector } from 'react-redux';

const PeopleModal = ({ show, tab, setTab, onClose }) => {
  const publicProfile = useSelector((state) => state.publicProfile);
  const { profileInfo } = publicProfile;

  return (
    <div className={`${styles.modal} ${show ? styles.show : ''}`}>
      <div className={styles.modalWrapper}>
        <img
          className={styles.close}
          src={closeIcn}
          alt='close'
          onClick={() => onClose()}
        />
        <div className={styles.tab}>
          <div
            className={styles.tabItem}
            data-active={tab === 0}
            onClick={() => setTab(0)}
          >
            <span>{profileInfo?.relation?.totalFollowers} Followers</span>
          </div>
          <div
            className={styles.tabItem}
            data-active={tab === 1}
            onClick={() => setTab(1)}
          >
            <span>{profileInfo?.relation?.totalFollowings} Following</span>
          </div>
        </div>
        <div className={styles.content}>
          {tab === 1 && (
            <FollowerList
              type='following'
              profileId={profileInfo?.profile?.id}
              onClose={onClose}
            />
          )}
          {tab === 0 && (
            <FollowerList
              type='followers'
              profileId={profileInfo?.profile.id}
              onClose={onClose}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default PeopleModal;
